import { ApiDefinitionArticle } from '@/types/api-definitions';

export interface ArticlesState {
  articlesByApiId: Record<string, ApiDefinitionArticle[]>;
  loading: Record<string, boolean>;
  error: string | null;
}

export const initialArticlesState: ArticlesState = {
  articlesByApiId: {},
  loading: {},
  error: null,
};
